import _toConsumableArray from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/* eslint no-underscore-dangle: "off" */
import { window, document } from 'ssr-window';
import $ from 'dom7';
import Template7 from 'template7';
import Utils from '../../utils/utils';
import vdom from './vdom';
import patch from './patch';
import componentMixins from './component-mixins';

var Component =
/*#__PURE__*/
function () {
  function Component(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var extendContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var children = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, Component);

    var id = Utils.id();
    var self = this;
    Utils.merge(self, {
      $props: {}
    }, extendContext, {
      $: $,
      $$: $,
      $dom7: $,
      $app: app,
      $f7: app,
      $options: Utils.extend({
        id: id
      }, options),
      $id: options.isClassComponent ? self.constructor.id : options.id || id,
      $mixins: options.isClassComponent ? self.constructor.mixins : options.mixins,
      $children: children || []
    });
    var $options = self.$options;

    if (self.$mixins && self.$mixins.length) {
      for (var i = self.$mixins.length - 1; i >= 0; i -= 1) {
        var mixin = self.$mixins[i];

        if (typeof mixin === 'string') {
          if (componentMixins[mixin]) self.$mixins[i] = componentMixins[mixin];else self.$mixins.splice(i, 1);
        }
      }
    }

    Object.defineProperty(self, '$slots', {
      enumerable: true,
      configurable: true,
      get: function get() {
        var slots = {};
        self.$children.forEach(function (childVNode) {
          var childSlotName = 'default';

          if (childVNode.data) {
            childSlotName = childVNode.data.attrs && childVNode.data.attrs.slot || 'default';
          }

          if (!slots[childSlotName]) slots[childSlotName] = [];
          slots[childSlotName].push(childVNode);
        });
        return slots;
      }
    }); // Root data and methods

    Object.defineProperty(self, '$root', {
      enumerable: true,
      configurable: true,
      get: function get() {
        if (app.rootComponent) return app.rootComponent;
        var root = Utils.merge({}, app.data, app.methods);

        if (window && window.Proxy) {
          root = new window.Proxy(root, {
            set: function set(target, name, val) {
              app.data[name] = val;
            },
            deleteProperty: function deleteProperty(target, name) {
              delete app.data[name];
              delete app.methods[name];
            },
            has: function has(target, name) {
              return name in app.data || name in app.methods;
            }
          });
        }

        return root;
      },
      set: function set() {}
    }); // Bind render

    if ($options.render) $options.render = $options.render.bind(self); // Bind methods

    var methods = {};

    if (self.$mixins && self.$mixins.length) {
      self.$mixins.forEach(function (mixin) {
        if (mixin.methods) Object.assign(methods, mixin.methods);
      });
    }

    if ($options.methods) {
      Object.assign(methods, $options.methods);
    }

    Object.keys(methods).forEach(function (methodName) {
      self[methodName] = methods[methodName].bind(self);
    }); // Bind Events

    if ($options.on) {
      Object.keys($options.on).forEach(function (eventName) {
        $options.on[eventName] = $options.on[eventName].bind(self);
      });
    }

    if ($options.once) {
      Object.keys($options.once).forEach(function (eventName) {
        $options.once[eventName] = $options.once[eventName].bind(self);
      });
    }

    self.$style = $options.isClassComponent ? self.constructor.style : $options.style;
    self.$styleScoped = $options.isClassComponent ? self.constructor.styleScoped : $options.styleScoped;
    self.__updateQueue = [];
    return new Promise(function (resolve, reject) {
      self.$hook('data', true).then(function (datas) {
        var data = {};
        datas.forEach(function (dt) {
          Object.assign(data, dt || {});
        });
        Utils.extend(self, data);
        self.$hook('beforeCreate');
        var html = self.$render();

        if (self.$options.el) {
          html = html.trim();
          self.$vnode = vdom(html, self, true);

          if (self.$style) {
            self.$styleEl = document.createElement('style');
            self.$styleEl.innerHTML = self.$style;
          }

          self.el = self.$options.el;
          patch(self.el, self.$vnode);
          self.el = self.$vnode.elm;
          self.$el = $(self.el);
          self.$attachEvents();
          self.el.f7Component = self;
          self.$hook('created');
          self.$mount();
          resolve(self);
          return;
        } // Make Dom


        if (html && typeof html === 'string') {
          html = html.trim();
          self.$vnode = vdom(html, self, true);
          self.el = document.createElement(self.$vnode.sel || 'div');
          patch(self.el, self.$vnode);
          self.$el = $(self.el);
        } else if (html) {
          self.el = html;
          self.$el = $(self.el);
        }

        if (self.$style) {
          self.$styleEl = document.createElement('style');
          self.$styleEl.innerHTML = self.$style;
        }

        self.$attachEvents();

        if (self.el) {
          self.el.f7Component = self;
        }

        self.$hook('created');
        resolve(self);
      }).catch(function (err) {
        reject(err);
      });
    });
  }

  _createClass(Component, [{
    key: "$attachEvents",
    value: function $attachEvents() {
      var self = this;
      var $options = self.$options,
          $el = self.$el;

      if (self.$mixins && self.$mixins.length) {
        self.$detachEventsHandlers = {};
        self.$mixins.forEach(function (mixin) {
          if (mixin.on) {
            Object.keys(mixin.on).forEach(function (eventName) {
              var handler = mixin.on[eventName].bind(self);
              if (!self.$detachEventsHandlers[eventName]) self.$detachEventsHandlers[eventName] = [];
              self.$detachEventsHandlers[eventName].push(handler);
              $el.on(Utils.eventNameToColonCase(eventName), handler);
            });
          }

          if (mixin.once) {
            Object.keys(mixin.once).forEach(function (eventName) {
              var handler = mixin.once[eventName].bind(self);
              if (!self.$detachEventsHandlers[eventName]) self.$detachEventsHandlers[eventName] = [];
              self.$detachEventsHandlers[eventName].push(handler);
              $el.once(Utils.eventNameToColonCase(eventName), handler);
            });
          }
        });
      }

      if ($options.on) {
        Object.keys($options.on).forEach(function (eventName) {
          $el.on(Utils.eventNameToColonCase(eventName), $options.on[eventName]);
        });
      }

      if ($options.once) {
        Object.keys($options.once).forEach(function (eventName) {
          $el.once(Utils.eventNameToColonCase(eventName), $options.once[eventName]);
        });
      }
    }
  }, {
    key: "$detachEvents",
    value: function $detachEvents() {
      var self = this;
      var $options = self.$options,
          $el = self.$el;

      if ($options.on) {
        Object.keys($options.on).forEach(function (eventName) {
          $el.off(Utils.eventNameToColonCase(eventName), $options.on[eventName]);
        });
      }

      if ($options.once) {
        Object.keys($options.once).forEach(function (eventName) {
          $el.off(Utils.eventNameToColonCase(eventName), $options.once[eventName]);
        });
      }

      if (!self.$detachEventsHandlers) return;
      Object.keys(self.$detachEventsHandlers).forEach(function (eventName) {
        var handlers = self.$detachEventsHandlers[eventName];
        handlers.forEach(function (handler) {
          $el.off(Utils.eventNameToColonCase(eventName), handler);
        });
        self.$detachEventsHandlers[eventName] = [];
        delete self.$detachEventsHandlers[eventName];
      });
      self.$detachEventsHandlers = null;
      delete self.$detachEventsHandlers;
    }
  }, {
    key: "$render",
    value: function $render() {
      var self = this;
      var $options = self.$options;
      var html = '';

      if ($options.render) {
        html = $options.render();
      } else if (self.render) {
        html = self.render.call(self);
      } else if ($options.template) {
        if (typeof $options.template === 'string') {
          html = Template7.compile($options.template)(self);
        } else {
          // Supposed to be function
          html = $options.template(self);
        }
      }

      return html;
    }
  }, {
    key: "$startUpdateQueue",
    value: function $startUpdateQueue() {
      var self = this;
      if (self.__requestAnimationFrameId) return;

      function update() {
        var html = self.$render(); // Make Dom

        if (html && typeof html === 'string') {
          html = html.trim();
          var newVNode = vdom(html, self, false);
          self.$vnode = patch(self.$vnode, newVNode);
        }
      }

      self.__requestAnimationFrameId = window.requestAnimationFrame(function () {
        if (self.__updateIsPending) update();

        var resolvers = _toConsumableArray(self.__updateQueue);

        self.__updateQueue = [];
        self.__updateIsPending = false;
        window.cancelAnimationFrame(self.__requestAnimationFrameId);
        delete self.__requestAnimationFrameId;
        delete self.__updateIsPending;
        resolvers.forEach(function (resolver) {
          return resolver();
        });
        resolvers = [];
      });
    }
  }, {
    key: "$tick",
    value: function $tick(callback) {
      var self = this;
      return new Promise(function (resolve) {
        function resolver() {
          resolve();
          if (callback) callback();
        }

        self.__updateQueue.push(resolver);

        self.$startUpdateQueue();
      });
    }
  }, {
    key: "$update",
    value: function $update(callback) {
      var self = this;
      return new Promise(function (resolve) {
        function resolver() {
          resolve();
          if (callback) callback();
        }

        self.__updateIsPending = true;

        self.__updateQueue.push(resolver);

        self.$startUpdateQueue();
      });
    }
  }, {
    key: "$setState",
    value: function $setState() {
      var mergeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var self = this;
      Utils.merge(self, mergeState);
      return self.$update(callback);
    }
  }, {
    key: "$f7ready",
    value: function $f7ready(callback) {
      var _this = this;

      if (this.$f7.initialized) {
        callback(this.$f7);
        return;
      }

      this.$f7.once('init', function () {
        callback(_this.$f7);
      });
    }
  }, {
    key: "$mount",
    value: function $mount(mountMethod) {
      var self = this;
      self.$hook('beforeMount');
      if (self.$styleEl) $('head').append(self.$styleEl);
      if (mountMethod) mountMethod(self.el);
      self.$hook('mounted');
    }
  }, {
    key: "$destroy",
    value: function $destroy() {
      var self = this;
      self.$hook('beforeDestroy');
      if (self.$styleEl) $(self.$styleEl).remove();
      self.$detachEvents();
      self.$hook('destroyed'); // Delete component instance

      if (self.el && self.el.f7Component) {
        self.el.f7Component = null;
        delete self.el.f7Component;
      } // Patch with empty node


      if (self.$vnode) {
        self.$vnode = patch(self.$vnode, {
          sel: self.$vnode.sel,
          data: {}
        });
      } // Clear update queue


      window.cancelAnimationFrame(self.__requestAnimationFrameId); // Delete all props

      Utils.deleteProps(self);
    }
  }, {
    key: "$hook",
    value: function $hook(name, async) {
      var self = this;

      if (async) {
        var promises = [];

        if (self.$mixins && self.$mixins.length) {
          self.$mixins.forEach(function (mixin) {
            if (mixin[name]) promises.push(mixin[name].call(self));
          });
        }

        if (self[name] && typeof self[name] === 'function') {
          promises.push(self[name].call(self));
        }

        if (self.$options[name]) {
          promises.push(self.$options[name].call(self));
        }

        return Promise.all(promises);
      }

      if (self.$mixins && self.$mixins.length) {
        self.$mixins.forEach(function (mixin) {
          if (mixin[name] && typeof mixin[name] === 'function') {
            mixin[name].call(self);
          }
        });
      }

      if (self.$options[name]) return self.$options[name].call(self);
      if (self[name]) return self[name].call(self);
      return undefined;
    }
  }]);

  return Component;
}();

export default Component;